var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page checkout" },
    [
      _c(
        "h2",
        {
          staticClass: "text-center mt-7",
          staticStyle: { "margin-bottom": "2px" },
        },
        [
          _vm._v("Bestellung für "),
          _vm.$store.state.orderArea
            ? _c("span", { staticClass: "text-no-wrap" }, [
                _vm._v(_vm._s(_vm.$store.state.orderArea)),
              ])
            : _c("span", { staticClass: "text-no-wrap" }, [
                _vm._v("Tisch " + _vm._s(_vm.$store.getters.table)),
              ]),
        ]
      ),
      _c("div", { staticClass: "text-center" }, [
        _c("h4", { staticClass: "mb-6" }, [
          _vm._v("Gesamtsumme: "),
          _c("span", { staticClass: "textFont" }, [
            _vm._v(_vm._s(_vm._f("price")(_vm.total))),
          ]),
        ]),
      ]),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "v-stepper",
            {
              staticClass: "vvd orderform",
              attrs: { vertical: "", id: "stepper" },
              model: {
                value: _vm.currentStep,
                callback: function ($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep",
              },
            },
            [
              _c(
                "v-stepper-step",
                {
                  attrs: { complete: _vm.currentStep > 1, step: "1" },
                  nativeOn: {
                    "&click": function ($event) {
                      _vm.currentStep = 1
                    },
                  },
                },
                [
                  _c("div", { staticClass: "nice-title small" }, [
                    _vm._v("Deine Bestelldaten"),
                  ]),
                ]
              ),
              _c("v-stepper-content", { attrs: { step: "1" } }, [
                _vm.usecase.length > 0
                  ? _c(
                      "div",
                      { attrs: { id: "checkData" } },
                      [
                        _c(
                          "div",
                          { staticClass: "bestelldaten pt-1" },
                          [
                            _c(
                              "v-form",
                              {
                                ref: "checkoutFormInhouse",
                                attrs: { "lazy-validation": "" },
                                model: {
                                  value: _vm.valid,
                                  callback: function ($$v) {
                                    _vm.valid = $$v
                                  },
                                  expression: "valid",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    outlined: "",
                                    label: _vm.selfServiceEnabled
                                      ? "Name*"
                                      : "Name (optional)",
                                    rules: _vm.nameRules,
                                    placeholder: "Name",
                                    illed: "",
                                    "hide-details": "",
                                  },
                                  on: {
                                    focus: _vm.hideToolbar,
                                    blur: _vm.unhideToolbar,
                                  },
                                  model: {
                                    value: _vm.name,
                                    callback: function ($$v) {
                                      _vm.name = $$v
                                    },
                                    expression: "name",
                                  },
                                }),
                                _vm.selfServiceEnabled
                                  ? _c("v-text-field", {
                                      ref: "phone",
                                      attrs: {
                                        outlined: "",
                                        rules: _vm.phoneRules,
                                        label: "Mobilnummer*",
                                        placeholder: "",
                                        illed: "",
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          return _vm.phoneKeydown($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.phone,
                                        callback: function ($$v) {
                                          _vm.phone = $$v
                                        },
                                        expression: "phone",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "spacer-15" }),
                        _vm.$store.state.enableOrderNote
                          ? [
                              _c("h4", { staticClass: "mt-4" }, [
                                _vm._v("Hinweise zur Bestellung"),
                              ]),
                              _c("v-text-field", {
                                staticClass: "nolabel",
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  clearable: "",
                                  illed: "",
                                },
                                model: {
                                  value: _vm.note,
                                  callback: function ($$v) {
                                    _vm.note = $$v
                                  },
                                  expression: "note",
                                },
                              }),
                            ]
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "mt-4 mt-4" },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "mt-3 orderBtn wallet-width text-none rounded100",
                                    attrs: { color: "green", dark: "" },
                                    nativeOn: {
                                      "&click": function ($event) {
                                        return _vm.doOrder.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" Zahlungspflichtig bestellen ")]
                                ),
                              ],
                              1
                            ),
                            _c("orderconsent"),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mt-3",
                            staticStyle: { color: "white" },
                          },
                          [_vm._v("Die Bezahlung erfolgt beim Kellner! ")]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("ssl-seal"),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-btn",
            {
              staticClass: "text-none btn-df okBtn",
              staticStyle: { "margin-top": "25px" },
              on: { click: _vm.gotoSummary },
            },
            [_vm._v(" Bestellung abbrechen ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "spacer-25" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }